import { createContext, useContext, useRef, useState } from "react";
import type { ReactNode } from "react";
import CompanySelectorPopup from "./components/CompanySelectorPopUp";
import { commonStrings } from "./components/StringBundle";
import type { CompanyOption, AutoLogoutContextValue, QuoteLineGridItem, QuoteLineViewDetails } from "./types";

const AutoLogoutContext = createContext<AutoLogoutContextValue | undefined>(undefined);

export const AutoLogoutProvider = ({ children }: { children: ReactNode }) => {
  const [openSamplePricing, setOpenSamplePricing] = useState<boolean>(false);
  const [selectedQuoteItemData, setSelectedQuoteItemData] = useState<QuoteLineGridItem | null>(null);
  const [quotationitemDetails, setQuotationitemDetails] = useState<QuoteLineViewDetails | null>(null);
  const [procceedButtonLabel, setProcceedButtonLabel] = useState<string>("");
  const [companyPopupOpen, setCompanyPopupOpen] = useState<boolean>(false);
  const [selectedCompanyName, setSelectedCompanyName] = useState<CompanyOption | null>(
    sessionStorage.getItem("companyNameToCreate")
      ? { value: sessionStorage.getItem("companyNameToCreate") as string }
      : { value: commonStrings.ccl }
  );
  const saveHandlerRef = useRef<(() => void) | null>(null);

  const registerSaveHandler = (handler: () => void): void => {
    saveHandlerRef.current = handler;
  };

  const invokeSaveHandler = (): void => {
    if (selectedCompanyName) {
      setCompanyPopupOpen(false);
      setSelectedCompanyName(selectedCompanyName);
      sessionStorage.setItem("companyNameToCreate", selectedCompanyName.value);
    }
    if (saveHandlerRef.current) {
      saveHandlerRef.current();
    }
  };

  return (
    <AutoLogoutContext.Provider
      value={{
        openSamplePricing,
        setOpenSamplePricing,
        selectedQuoteItemData,
        setSelectedQuoteItemData,
        quotationitemDetails,
        setQuotationitemDetails,
        companyPopupOpen,
        setCompanyPopupOpen,
        selectedCompanyName,
        setSelectedCompanyName,
        registerSaveHandler,
        invokeSaveHandler,
        setProcceedButtonLabel,
        procceedButtonLabel,
      }}
    >
      <CompanySelectorPopup />
      {children}
    </AutoLogoutContext.Provider>
  );
};

export const useAutoLogout = (): AutoLogoutContextValue => useContext(AutoLogoutContext) as AutoLogoutContextValue;
